import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ModalDialog } from '../../common';

import styles from './css/UpdateReimbursementModal.module.css';

const UpdateReimbursementModal = ({
  onButtonClick = () => { },
  onClose = () => { },
  show = false,
}) => {
  const { t } = useTranslation('myAccount');

  const handleOnClose = useCallback(() => {
    if (show) {
      onClose();
    }
  }, [onClose, show]);

  const handleOnButtonClick = useCallback(() => {
    if (show) {
      onButtonClick();
      handleOnClose();
    }
  }, [handleOnClose, onButtonClick, show]);

  return (
    <ModalDialog
      onClose={handleOnClose}
      show={show}
    >
      <div className={styles.UpdateReimModalContainer}>
        <h1>{t('reimbursementSection.updateModal.title')}</h1>

        <span>
          <Trans
            components={{ b: <strong /> }}
            i18nKey="reimbursementSection.updateModal.description"
            ns="myAccount"
            t={t}
          />
        </span>

        <div className={styles.Actions}>
          <button
            className={styles.UpdateReimModalButtonCancel}
            onClick={handleOnClose}
            type="button"
          >
            {t('reimbursementSection.updateModal.cancel')}
          </button>

          <button
            className={styles.UpdateReimModalButton}
            onClick={handleOnButtonClick}
            type="button"
          >
            {t('reimbursementSection.updateModal.button')}
          </button>
        </div>
      </div>
    </ModalDialog>
  );
};

export { UpdateReimbursementModal };
